import React, { useState } from "react";
import PropTypes from "prop-types";
import { Grid, Button, TextField, Tooltip } from "@material-ui/core";
import clsx from "clsx";
import SearchCategoryChips from "../../components/SearchCategoryChips/SearchCategoryChips.jsx"
import { useStyles } from "./styles";

const INVITE_CHIPS = [
  { label: "Account Number", value: "AccountNumber" },
  { label: "Credential", value: "Credential" },
  { label: "Vehicle", value: "Vehicle" },
  { label: "Contact Info", value: "ContactInfo" },
  { label: "Access Group", value: "AccessGroup" },
];

const OneParkInviteSearchButton = ({ onSearch, loading }) => {
  const classes = useStyles();
  const [category, setCategory] = useState("ContactInfo");
  const [searchTerm, setSearchTerm] = useState("");

  const setSearch = () => {
    onSearch({
      searchCategory: category,
      searchTerm: searchTerm.trim(),
      page: 1,
    });
  };

  const isDisabled = () => {
    if (category === "AccountNumber" || category === "Credential") {
      return loading || !category || !searchTerm;
    }
    return loading || !category || !searchTerm || searchTerm.length < 3;
  };

  const getHelperText = () => {
    if (category === "AccountNumber" || category === "Credential") {
      return " ";
    }
    return "minimum 3 characters";
  };

  return (
    <Grid container spacing={2} className={clsx("category", classes.root, "onepark-invite-search-container")}>
      <Grid item xs={12} sm={6} className={classes.chipSection}>
        <SearchCategoryChips
          chips={INVITE_CHIPS}
          category={category}
          setCategory={setCategory}
          className={clsx("onepark-invite-search-chips")}
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <Tooltip title="" arrow placement="top-start">
          <TextField
            label="Search for..."
            variant="outlined"
            className={clsx("search-field", classes.searchInput, "onepark-invite-search-input")}
            helperText={getHelperText()}
            value={searchTerm}
            onChange={(e) => {
              const value = e.target.value;
              const normalizedValue = value.replace(/^\s+/, "");
              setSearchTerm(normalizedValue);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                if (!isDisabled()) setSearch();
              }
            }}
          />
        </Tooltip>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Button
          type="submit"
          className={clsx("search-btn-submit", classes.searchButton, "onepark-invite-search-btn")}
          variant="contained"
          color="primary"
          onClick={() => setSearch()}
          disabled={isDisabled()}
        >
          Search
        </Button>
      </Grid>
    </Grid>
  );
};

OneParkInviteSearchButton.defaultProps = {
  onSearch: () => {},
  loading: false,
};

OneParkInviteSearchButton.propTypes = {
  onSearch: PropTypes.func,
  loading: PropTypes.bool,
};

export default OneParkInviteSearchButton;
